import React, {
    useEffect,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import { useService } from './service';
import { lookupPlaceholderIdByUrl } from './utils';
import {
    getBrowsingCountryIso,
    getCurrencyIso,
    getCustomerId,
    getLanguageIso,
    getUserMode,
    getCountryState,
    getIsFtdWrapperFlag,
    getIsMobileWrapperFlag,
    getIsPromotionPermittedWrapperFlag,
    getIsVipWrapperFlag,
    getRmsWrapperData,
    getSerialWrapperData,
    onIsFtdFlagChange,
    onIsPromotionPermittedFlagChange,
    onIsVipFlagChange,
    onRmsDataChange,
    onSerialDataChange,
} from '~shared/utils/user';
import {
    getBannersFilepath,
} from '~spa/SpectateConfig';
import { buildSpectateStaticAssetUrl } from '~spa/Utils/Spectate';

const PLACEHOLDERS_JSON_URL = buildSpectateStaticAssetUrl(
    getBannersFilepath()
);

const Banners = ({ url }) => {
    const placeholders = useService(PLACEHOLDERS_JSON_URL);

    // config
    const [placeholderId, setPlaceholderId] = useState('');
    const languageCode = getLanguageIso();
    const deviceCode = getIsMobileWrapperFlag() ? 'mobile' : 'desktop';

    // segmentation
    const [vip, setVip] = useState(getIsVipWrapperFlag());
    const [ftd, setFtd] = useState(getIsFtdWrapperFlag());
    const countries = getBrowsingCountryIso();
    const currency = getCurrencyIso();
    const countryState = getCountryState();
    const userMode = getUserMode();
    const [rms, setRms] = useState(getRmsWrapperData());
    const [serials, setSerials] = useState(getSerialWrapperData() || '');
    const cid = getCustomerId() || '';
    const [isPromotionPermitted, setIsPromotionPermitted] = useState(
        getIsPromotionPermittedWrapperFlag()
    );

    useEffect(() => {
        const clientStateSubscribers = [];

        clientStateSubscribers.push(
            onIsFtdFlagChange(
                (key, isFtd) => setFtd(isFtd)
            )
        );

        clientStateSubscribers.push(
            onIsPromotionPermittedFlagChange(
                (key, isPromotionPermitted) => setIsPromotionPermitted(isPromotionPermitted)
            )
        );

        clientStateSubscribers.push(
            onIsVipFlagChange(
                (key, isVip) => setVip(isVip)
            )
        );

        clientStateSubscribers.push(
            onRmsDataChange(
                (key, rms) => setRms(rms)
            )
        );

        clientStateSubscribers.push(
            onSerialDataChange(
                (key, serial) => setSerials(serial)
            )
        );

        return function cleanup() {
            clientStateSubscribers.forEach(
                (unsubscribe) => unsubscribe()
            );
        };
    }, []);

    useEffect(() => {
        setPlaceholderId(
            lookupPlaceholderIdByUrl(placeholders, url)
        );
    }, [ placeholders, url ]);

    const config = {
        placeholderId,
        deviceCode,
        languageCode,
    };
    const segmentation = {
        vip,
        ftd,
        countries,
        currency,
        userMode,
        serials,
        cid,
        isPromotionPermitted,
        states: countryState,
        riskFactor: rms, // Important!! riskFactor is a wrong field name in banners component!
    };

    return placeholderId && (
        <banner-888
            config={JSON.stringify(config)}
            segmentation={JSON.stringify(segmentation)}
        />
    );
};

Banners.propTypes = {
    url: PropTypes.string.isRequired,
};

export default Banners;
